import React from 'react';

import Container from '@mui/material/Container';

import { connections as listedConnections } from './utils';
import { ConnectionType, ConnectionSystem } from 'generated/graphql';
import ConnectionList from 'Components/connections/ConnectionList';
import { ListedConnection } from './types/listedConnection';

interface ConnectionsListContentProps {
    connections: ConnectionType[];
}

const ConnectionsListContent: React.FC<ConnectionsListContentProps> = ({
    connections,
}) => {
    const expectedConnectionsSorting = Object.values(ConnectionSystem);

    const sortConnections = (a: ConnectionType, b: ConnectionType) =>
        expectedConnectionsSorting.indexOf(a.system) -
        expectedConnectionsSorting.indexOf(b.system);

    const orderedConnections = connections
        ? [...connections].sort(sortConnections)
        : [];

    const activeConnection = orderedConnections.find((conn) => conn.system);

    const availableConnections = listedConnections.reduce<ListedConnection[]>(
        (connections, connection) => {
            const connectionByName = orderedConnections.find(
                (conn) =>
                    conn.system.toLowerCase() === connection.toLowerCase(),
            );

            if (
                !connectionByName &&
                activeConnection &&
                activeConnection.system.toLowerCase() !==
                    connection.toLowerCase()
            ) {
                return connections;
            }

            connections.push({
                connected: !!connectionByName,
                connection,
                organizationId: connectionByName?.organizationId,
            });

            return connections;
        },
        [],
    );

    return (
        <Container sx={{ padding: '0 !important', display: 'flex', gap: 3 }}>
            <ConnectionList availableConnections={availableConnections} />
        </Container>
    );
};

export default ConnectionsListContent;
